/* DEMO (3 Nov): instant feedback when a customer presses BUY NOW.
   1. The button changes to 'Adding...' the moment it is pressed, then 'Added' with a tick (or back to normal if the add failed), so there is no silent pause before the basket panel opens.
   2. The basket count in the header (the bubble on phones, the (n) on computers) is refreshed straight after an add; on phones it used to appear only after the next page loaded.
   3. (3 Nov, late) On the main product page the basket drawer now slides open the instant BUY NOW is pressed, with a small 'Adding to your basket...' cover over it, instead of waiting about half a second for Shopify to confirm the add. When the add is confirmed the cover is removed and the drawer shows the new basket. If the add fails the drawer closes again and the usual 'out of stock' message shows. Undo = delete the 'openEarly' / 'closeEarly' lines and functions below.
   4. (4 Nov) Fix: pressing NOTIFY ME on a sold-out product made a spinning circle appear on every other product in the list and stay there. The theme's old add-to-basket code (timber.js) treats the NOTIFY ME link like a BUY NOW button, because it has the same class, and switches every spinner on. Now, for a moment after a NOTIFY ME press, those spinners are kept hidden. The NOTIFY ME pop-up itself is untouched. Undo = delete the 'hushSpinners' lines and function.
   Works with the collection grid, Featured, Recently viewed, Frequently bought together, the homepage rows and the main product page button. It does not add anything to the basket itself and does not stop or replace any other script: it only listens, then wraps the theme's own 'added' / 'failed' routines for the length of one add. Loaded just before dc-grid.js in snippets/oldIE-js.liquid. Undo = delete this file and its one script line there. */
(function () {
  'use strict';
  if (window.__dcFb) return;
  window.__dcFb = 1;
  var SEL = 'li.product .add-cart-btn .add-to-cart-button, #add-to-cart';
  var cur = null;

  function drawer() { return document.querySelector('.fcsb-mini-cart-sidebar'); }
  function backdrop() { return document.querySelector('.fcsb-mini-cart-backdrop'); }

  /* open the basket drawer straight away, with a cover saying the add is in progress */
  function openEarly() {
    var sd = drawer();
    if (!sd) return false;
    var cv = document.getElementById('dc-adding-cover');
    if (!cv) {
      cv = document.createElement('div');
      cv.id = 'dc-adding-cover';
      cv.setAttribute('role', 'status');
      cv.textContent = 'Adding to your basket…';
      cv.style.cssText = 'position:absolute;left:0;right:0;top:0;bottom:0;z-index:50;display:flex;align-items:center;justify-content:center;background:rgba(246,239,228,.88);color:#392919;font:800 18px/1.3 Arial,Helvetica,sans-serif;text-align:center;padding:20px';
      if (getComputedStyle(sd).position === 'static') sd.style.position = 'relative';
      sd.appendChild(cv);
    }
    var bd = backdrop();
    if (bd) bd.classList.add('fcsb-show');
    sd.setAttribute('style', (sd.getAttribute('style') || '').replace(/display:[^;]*;?/g, '') + ';display:flex');
    return true;
  }
  function dropCover() {
    var cv = document.getElementById('dc-adding-cover');
    if (cv && cv.parentNode) cv.parentNode.removeChild(cv);
  }
  function closeEarly() {
    dropCover();
    var sd = drawer(), bd = backdrop();
    if (bd) bd.classList.remove('fcsb-show');
    if (sd) sd.style.display = 'none';
  }

  /* NOTIFY ME press: keep the theme's old spinners hidden for a moment (hushSpinners) */
  var hushing = false, hushObs = null;
  function hideSpinners() {
    [].forEach.call(document.querySelectorAll('.add-cart-btn .loading'), function (e) {
      if (e.style.display !== 'none') e.style.display = 'none';
    });
  }
  function hushSpinners() {
    hushing = true;
    if (!hushObs && window.MutationObserver) {
      /* runs right after the old code switches them on, before the screen repaints, so there is no flash */
      hushObs = new MutationObserver(function () { if (hushing) hideSpinners(); });
      hushObs.observe(document.body, { attributes: true, attributeFilter: ['style'], subtree: true });
    }
    setTimeout(hideSpinners, 0);
    setTimeout(function () { hushing = false; hideSpinners(); }, 2500);
  }

  function syncBadge() {
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var n = c.item_count || 0;
        [].forEach.call(document.querySelectorAll('#main-nav-basket .item-count'), function (e) { e.textContent = '(' + n + ')'; });
        var a = document.getElementById('mobile-basket-button-anchor');
        if (a) {
          var s = a.querySelector('.item-count');
          if (n > 0) {
            if (!s) { s = document.createElement('span'); s.className = 'item-count'; a.appendChild(s); }
            s.textContent = String(n);
          } else if (s && s.parentNode) {
            s.parentNode.removeChild(s);
          }
        }
      })
      .catch(function () {});
  }

  function finish(c, ok) {
    if (!c || c.done) return;
    c.done = true;
    if (cur === c) cur = null;
    var b = c.btn;
    if (ok) { b.textContent = 'Added ✓'; }
    setTimeout(function () {
      b.innerHTML = c.html;
      b.style.pointerEvents = c.pe;
    }, ok ? 1600 : 0);
  }

  function begin(btn) {
    if (cur) return;
    var c = { btn: btn, html: btn.innerHTML, pe: btn.style.pointerEvents, done: false, early: false };
    cur = c;
    btn.textContent = 'Adding…';
    btn.style.pointerEvents = 'none';
    if (btn.id === 'add-to-cart') c.early = openEarly();

    var okO = window.addToCartOk, failO = window.addToCartFail;
    var okW, failW;
    function unwrap() {
      if (window.addToCartOk === okW) window.addToCartOk = okO;
      if (window.addToCartFail === failW) window.addToCartFail = failO;
    }
    okW = function () {
      unwrap();
      finish(c, true);
      if (c.early) dropCover();
      setTimeout(syncBadge, 400);
      setTimeout(syncBadge, 1500);
      return okO ? okO.apply(this, arguments) : undefined;
    };
    failW = function () {
      unwrap();
      finish(c, false);
      if (c.early) closeEarly();
      return failO ? failO.apply(this, arguments) : undefined;
    };
    window.addToCartOk = okW;
    window.addToCartFail = failW;
    /* safety: if nothing answers in 8 seconds, put the button back and close the early drawer */
    setTimeout(function () { if (!c.done) { unwrap(); finish(c, false); if (c.early) closeEarly(); } }, 8000);
  }

  /* listens only; registered before the theme's own click code so it sees the press first */
  window.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('.BIS_trigger')) { hushSpinners(); return; }
    var b = t.closest(SEL);
    if (!b || b.disabled || b.classList.contains('disabled')) return;
    if (b.id === 'add-to-cart' && !document.getElementById('AddToCartForm')) return;
    if (b.id !== 'add-to-cart' && !b.getAttribute('data-proid')) return;
    begin(b);
  }, true);
})();
